// src/app/(dashboard)/meter/components/MeterSearchForm.tsx
import React from "react";

interface MeterSearchFormProps {
  q: string;
  pageSize: number;
  status: string;
  meterType: string;
}

const INPUT_STYLES = [
  "h-11 w-full sm:w-64",
  "rounded-xl border px-3 text-sm outline-none",
  "border-slate-200 bg-white text-slate-900 placeholder:text-slate-400",
  "focus:border-slate-400 focus:ring-2 focus:ring-slate-200",
  "dark:border-slate-800 dark:bg-slate-900 dark:text-slate-50 dark:placeholder:text-slate-500",
  "dark:focus:border-slate-700 dark:focus:ring-slate-800",
].join(" ");

const SELECT_WRAPPER_STYLES = "relative w-full sm:w-40";

const SELECT_STYLES = [
  "h-11 w-full appearance-none",
  "rounded-xl border pl-3 pr-9 text-sm outline-none",
  "border-slate-200 bg-white text-slate-900",
  "focus:border-slate-400 focus:ring-2 focus:ring-slate-200",
  "dark:border-slate-800 dark:bg-slate-900 dark:text-slate-50",
  "dark:focus:border-slate-700 dark:focus:ring-slate-800",
].join(" ");

const SELECT_CHEVRON_STYLES =
  "pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500";

const BUTTON_STYLES = [
  "h-11 shrink-0 rounded-xl border px-4 text-sm font-medium",
  "border-slate-200 bg-white text-slate-900 hover:bg-slate-50 active:bg-slate-100",
  "dark:border-slate-800 dark:bg-slate-900 dark:text-slate-50 dark:hover:bg-slate-800/60",
].join(" ");

export function MeterSearchForm({
  q,
  pageSize,
  status,
  meterType,
}: MeterSearchFormProps) {
  return (
    <form className="flex w-full flex-wrap items-center gap-2 sm:w-auto sm:flex-nowrap">
      <input
        name="q"
        defaultValue={q}
        placeholder="ค้นหาด้วยเลข PEA NO."
        className={INPUT_STYLES}
      />
      <div className={SELECT_WRAPPER_STYLES}>
        <select name="status" defaultValue={status} className={SELECT_STYLES}>
          <option value="">สถานะทั้งหมด</option>
          <option value="online">ออนไลน์</option>
          <option value="offline">ออฟไลน์</option>
        </select>
        <ChevronDownIcon className={SELECT_CHEVRON_STYLES} />
      </div>
      <div className={SELECT_WRAPPER_STYLES}>
        <select
          name="meterType"
          defaultValue={meterType}
          className={SELECT_STYLES}
        >
          <option value="">ประเภททั้งหมด</option>
          <option value="Single-phase">1 เฟส</option>
          <option value="Three-phase">3 เฟส</option>
          <option value="CT-operated">มิเตอร์ CT</option>
        </select>
        <ChevronDownIcon className={SELECT_CHEVRON_STYLES} />
      </div>
      {/* Always reset to page 1 on new search/filter */}
      <input type="hidden" name="page" value="1" />
      <input type="hidden" name="pageSize" value={String(pageSize)} />
      <button type="submit" className={BUTTON_STYLES}>
        ค้นหา
      </button>
    </form>
  );
}

function ChevronDownIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}
